import clientApi from "@/services/byLawViewerAPI";

export default {
    fetchBylawForKeyword: async ({ commit }, keyword) => {
        try {
            await clientApi.getSearchResult(keyword)
            .then(response => { 
                if (response.status == 200) {
                    commit("loadSearchResult", response.data);
                } else {
                    commit("setError", null);
                }
            })
            .catch(error => {
                commit("setError", null);
                console.log(error);
            });
        } catch (error) {
            commit("setError", null);
        }
    }
};
